import PropTypes from "prop-types";

const H2RSelect = ({
	selected,
	options = [],
	onChange,
	css = "",
	colour = "dark",
	size = "small",
	label = "",
	chooseText = "Choose...",
	disabled = false,
}) => {
	return (
		<div className="w-full">
			<span
				className={`text-gray-500 tracking-wide font-semibold
				${size === "small" ? "text-xs" : "text-sm"}
				`}
			>
				{label}
			</span>
			<select
				disabled={disabled}
				className={`w-full cursor-pointer rounded transition duration-300 ease-in-out focus:outline-none focus:ring 
            ${size === "small" ? "text-sm px-1 py-1" : "text-lg px-4 py-1"}
   ${colour === "dark" && "bg-gray-700 focus:ring-main-500"}
   ${colour === "light" && "bg-gray-200  focus:ring-main-500 text-gray-800"}
 ${disabled && "opacity-25 cursor-auto"}
    ${css}
   `}
				value={selected}
				onChange={(e) => {
					if (e.target.value === "") {
						return null;
					}
					onChange(e.target.value);
				}}
			>
				<option value="">{chooseText}</option>
				{options.map((op) => {
					return (
						<option key={op.value} value={op.value}>
							{op.label}
						</option>
					);
				})}
			</select>
		</div>
	);
};

H2RSelect.propTypes = {
	selected: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	css: PropTypes.string,
	colour: PropTypes.string,
};

export default H2RSelect;
